import { Invoice, InvoiceBusinessState, InvoiceState, InvoiceSubkind } from "@oysterhr/schema"
import { ClientInvoiceState } from "../constants/invoices"

export const getClientInvoiceState = ({
  state,
  subkind,
  autoApprovedAt,
}: Pick<Invoice, "state" | "subkind" | "autoApprovedAt">): ClientInvoiceState => {
  if (state === InvoiceState.WaitingApproval) {
    if (subkind === InvoiceSubkind.OysterPrefunding) {
      return InvoiceBusinessState.ReadyForReview
    }
    return InvoiceBusinessState.WaitingApproval
  }
  if (state === InvoiceState.Draft) {
    return InvoiceBusinessState.Draft
  }
  if (state === InvoiceState.Voided) {
    return InvoiceBusinessState.Voided
  }
  if (state === InvoiceState.Disputed) {
    return InvoiceBusinessState.Disputed
  }
  if (autoApprovedAt) {
    return InvoiceBusinessState.AutoApproved
  }
  return InvoiceBusinessState.Approved
}
